import React, { useEffect, useState } from 'react'
import { FaCoins } from "react-icons/fa";
import { IoMdCart } from "react-icons/io";
import { IoPersonAdd } from "react-icons/io5";
import { MdInventory2 } from "react-icons/md";
import { useAuth } from '../../context/UserContext';
import adminServices from '../../services/AdminServices';
import utils from '../../utils';
import vendorServices from '../../services/VendorSevices';

function Summary() {
    const { user } = useAuth()
    const [stats, setStats] = useState()

    useEffect(() => {
        if (user?.is_admin) {
            adminStats()
        }
        if (user?.is_vendor) {
            vendorStats()
        }
    }, [user])

    const adminStats = () => {
        adminServices.getStats().then(
            res => {
                setStats(res.data)
            },
            err => {
                console.log(err);

            }
        )
    }
    const vendorStats = () => {
        vendorServices.getStoreStats().then(
            res => {
                setStats(res.data)
            },
            err => {
                console.log(err);

            }
        )
    }
    return (
        <div>
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                <div className="bg-white p-6 rounded-lg shadow">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="text-sm font-medium text-gray-500">Total Revenue</p>
                            <p className="text-3xl font-bold text-gray-900 mt-2">{utils.toCommas(stats?.revenue_total || 0)}</p>
                        </div>
                        <div className="p-2 bg-orange-100 rounded-full">
                            <span className="material-icons text-secondary"><FaCoins className='h-7 w-7' /></span>
                        </div>
                    </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="text-sm font-medium text-gray-500">Orders</p>
                            <p className="text-3xl font-bold text-gray-900 mt-2">{utils.toCommas(stats?.orders || 0)}</p>
                        </div>
                        <div className="p-2 bg-red-100 rounded-full">
                            <span className="material-icons text-primary"><IoMdCart className='h-7 w-7' /></span>
                        </div>
                    </div>
                </div>
                {user?.is_admin && (
                    <div className="bg-white p-6 rounded-lg shadow">
                        <div className="flex items-start justify-between">
                            <div>
                                <p className="text-sm font-medium text-gray-500">Users</p>
                                <p className="text-3xl font-bold text-gray-900 mt-2">{utils.toCommas(stats?.users_count || 0)}</p>
                            </div>
                            <div className="p-2 bg-orange-100 rounded-full">
                                <span className="material-icons text-secondary"><IoPersonAdd className='h-7 w-7' /></span>
                            </div>
                        </div>
                    </div>
                )}
                <div className="bg-white p-6 rounded-lg shadow">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="text-sm font-medium text-gray-500">Product Count</p>
                            <p className="text-3xl font-bold text-gray-900 mt-2">{utils.toCommas(stats?.products_count || 0)}</p>
                        </div>
                        <div className="p-2 bg-red-100 rounded-full">
                            <span className="material-icons text-primary"><MdInventory2 className='h-7 w-7' /></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Summary